@if (isWaitingForSearchResults()) {
  <div [class.loading-indicator-wrapper]="isDefaultVariant()">
    <div
      aria-live="assertive"
      aria-busy="true"
      role="status"
      tabindex="0"
      role="status"
      class="loader"
      aria-label="loading..."
    ></div>
  </div>
}
